<app-card *ngIf="activeCard"
          [card]="activeCard"
          [isResults]="_isResults"
          [isWordCloudReady]="isWordCloudReady"
          (onSubmit)="onSubmitHandler($event)"
></app-card>

<div *ngIf="activeCard" class="button-group">
  <button (click)="prevCard()" [ngClass]="{disabled: !canGoPrev()}">{{'__INTERACTION_PREVIOUS__' | translate}}</button>
  <button (click)="nextCard()" [ngClass]="{disabled: !canGoNext()}" class="filled">{{'__INTERACTION_NEXT__' | translate}}</button>
</div>
